export const createAuthorizationHeader = (token: string) => ({
  Authorization: `Bearer ${token}`,
})
